namespace $.$$ {

	export class $mol_svg_rect extends $.$mol_svg_rect {
		
		pos_x() {
			return this.pos()[ 0 ]
		}
		
		pos_y() {
			return this.pos()[ 1 ]
		}
		
	}
	
}
